import { useEffect, useState, useMemo } from 'react'
// import { debounce } from 'lodash'

export const useScrollVisibility = (elementId, threshold = 110) => {
   const [isTargetVisible, setIsTargetVisible] = useState(true)

   useEffect(() => {
      // const handleScroll = debounce(() => {
      const handleScroll = () => {
         const triggerElement = document.getElementById(elementId)
         if (triggerElement) {
            const triggerRect = triggerElement.getBoundingClientRect()
            const isVisible = triggerRect.bottom > threshold

            setIsTargetVisible(prevIsVisible => {
               if (prevIsVisible !== isVisible) {
                  return isVisible // Update the state only if it's different from the previous state
               }
               return prevIsVisible // Return the previous state unchanged
            })
         }
      }
      // }, 50)

      window.addEventListener('scroll', handleScroll)

      handleScroll()

      return () => {
         window.removeEventListener('scroll', handleScroll)
      }
   }, [elementId, threshold])

   return { isTargetVisible }
}

export const useElementInView = (elementId, threshold = 0) => {
   const [isVisible, setIsVisible] = useState(false)

   // useMemo to ensure the options object isn't recreated on every render
   const observerOptions = useMemo(
      () => ({
         // root: null,
         // rootMargin: '0px',
         threshold: threshold,
      }),
      [threshold]
   )

   useEffect(() => {
      // Define the handler inside useEffect to ensure it has the most up-to-date state
      const handleIntersection = entries => {
         const entry = entries[0]
         // IntersectionObserver doesn't call the callback repeatedly for the same intersection ratio
         setIsVisible(entry.isIntersecting)
      }

      // Only create a new observer if the target element is found
      const targetElement = document.getElementById(elementId)
      if (targetElement) {
         const observer = new IntersectionObserver(
            handleIntersection,
            observerOptions
         )
         observer.observe(targetElement)

         // Clean-up function to unobserve the element
         return () => observer.unobserve(targetElement)
      }
   }, [elementId, observerOptions]) // Dependencies are correctly listed, ensuring the effect only reruns when they change

   return isVisible // Return the primitive value directly for easier consumption
}

export const useIsScrolledToBottom = () => {
   const [isScrolledToBottom, setIsScrolledToBottom] = useState(false)

   useEffect(() => {
      const handleScroll = () => {

         const distanceFromBottom = document.documentElement.offsetHeight - (window.innerHeight + window.scrollY);
         const isBottom = distanceFromBottom <= 110; //
   
         setIsScrolledToBottom(prevIsBottom => {
            if (prevIsBottom !== isBottom) {
               return isBottom
            } else {
               return prevIsBottom
            }
         })
      }

      // Register the scroll event listener
      window.addEventListener('scroll', handleScroll)

      // Check the scroll position on mount in case already at the bottom
      handleScroll()

      // Cleanup: Remove the event listener
      return () => {
         window.removeEventListener('scroll', handleScroll)
      }
   }, []) // Empty dependency array means this effect runs once on mount

   return isScrolledToBottom
}
